import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, UserCog } from 'lucide-react';
import { UserProfile } from '@/types/user';
import { formatDistanceToNow } from 'date-fns';

interface PendingUsersSectionProps {
  users: UserProfile[];
  onUserClick: (user: UserProfile) => void;
  onUserUpdated: () => void;
}

export function PendingUsersSection({ users, onUserClick }: PendingUsersSectionProps) {
  if (users.length === 0) return null;

  return (
    <Card className="border-warning/30 bg-warning/5">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-warning">
          <AlertTriangle className="h-5 w-5" />
          Pending Approval ({users.length} {users.length === 1 ? 'user' : 'users'})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {users.map((user) => (
            <div
              key={user.id}
              className="flex items-center justify-between p-3 bg-card rounded-lg border"
            >
              <div className="flex flex-col">
                <span className="font-medium">
                  {user.display_name || user.email}
                </span>
                {user.display_name && (
                  <span className="text-sm text-muted-foreground">{user.email}</span>
                )}
                <span className="text-xs text-muted-foreground mt-1">
                  Self-signed up {user.created_at ? formatDistanceToNow(new Date(user.created_at), { addSuffix: true }) : 'recently'}
                </span>
              </div>
              <Button
                variant="default"
                size="sm"
                onClick={() => onUserClick(user)}
              >
                <UserCog className="h-4 w-4 mr-2" />
                Assign Role
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
